export let ItemFilterApiParam;

(function (ItemFilterApiParam) {
  ItemFilterApiParam["Pushable"] = "pushable";
  ItemFilterApiParam["Collectable"] = "collectable";
  ItemFilterApiParam["Draggable"] = "draggable";
})(ItemFilterApiParam || (ItemFilterApiParam = {}));

export let ItemAlertStatus;

(function (ItemAlertStatus) {
  ItemAlertStatus["MissingSubcategory"] = "missing_subcategory";
  ItemAlertStatus["ChangeDescription"] = "change_description";
  ItemAlertStatus["Black"] = "black";
  ItemAlertStatus["DarkGray"] = "dark_gray";
  ItemAlertStatus["PackageSize"] = "package_size";
  ItemAlertStatus["ReplicaProof"] = "replica_proof";
  ItemAlertStatus["UnderReview"] = "under_review";
  ItemAlertStatus["EligibleForAuthenticity"] = "eligible_for_authenticity";
  ItemAlertStatus["VerifiedOnlineAuthenticity"] = "verified_online_authenticity";
  ItemAlertStatus["DelayedPublication"] = "delayed_publication";
})(ItemAlertStatus || (ItemAlertStatus = {}));

export let ItemClosingAction;

(function (ItemClosingAction) {
  ItemClosingAction["Sold"] = "sold";
})(ItemClosingAction || (ItemClosingAction = {}));

export let ItemPriceSuggestionDisplayType;

(function (ItemPriceSuggestionDisplayType) {
  ItemPriceSuggestionDisplayType["Always"] = "always";
  ItemPriceSuggestionDisplayType["Banner"] = "banner";
  ItemPriceSuggestionDisplayType["Range"] = "range";
  ItemPriceSuggestionDisplayType["Off"] = "off";
})(ItemPriceSuggestionDisplayType || (ItemPriceSuggestionDisplayType = {}));

export let ItemDisposalConditions;

(function (ItemDisposalConditions) {
  ItemDisposalConditions[ItemDisposalConditions["None"] = 0] = "None";
  ItemDisposalConditions[ItemDisposalConditions["ForSell"] = 4] = "ForSell";
})(ItemDisposalConditions || (ItemDisposalConditions = {}));

export let ItemPerformanceListingScore;

(function (ItemPerformanceListingScore) {
  ItemPerformanceListingScore["BelowAverage"] = "below_average";
  ItemPerformanceListingScore["Average"] = "average";
  ItemPerformanceListingScore["AboveAverage"] = "above_average";
})(ItemPerformanceListingScore || (ItemPerformanceListingScore = {}));

export const MIN_PHOTO_COLLAGE_COUNT = 3;
export let ItemAfterUploadActions;

(function (ItemAfterUploadActions) {
  ItemAfterUploadActions["ShowOfflineVerificationModal"] = "show_offline_verification_modal";
})(ItemAfterUploadActions || (ItemAfterUploadActions = {}));